module.exports = __webpack_public_path__ + "media/images/responsive/page_common/noimage/landscape/deco_black-ea2213697aa8b632838db9966e7f6de3.png";